import ActivitiesRules from '../../../libs/business-logic/Activities.rules';
import CompositeCriteria from '../../../libs/CompositeCriteria';
import ChecklistCriteria from '../../../modules/activity/domain/criterias/ChecklistCriteria';
import StatusCriteria from '../../../modules/activity/domain/criterias/StatusCriteria';

const GREEN_ACTIVITY_STATUS_ID = 2;
const YELLOW_ACTIVITY_STATUS_ID = 3;
const RED_ACTIVITY_STATUS_ID = 4;

export default {
  getAdditionalOrdersActivities: (state) => state.additionalOrdersActivities,
  getActivitiesGroupedById: (state) => state.activitiesGroupedById,
  getAdditionalOrdersGreenActivities: (state) => ActivitiesRules
    .greenActivities(state.additionalOrdersActivities),

  parentSuperorderGreenChecklistActivities: (state) => {
    const compositeCriteria = new CompositeCriteria();
    const checklistCriteria = new ChecklistCriteria(true);
    const statusCriteria = new StatusCriteria(GREEN_ACTIVITY_STATUS_ID);

    compositeCriteria.addCriteria(checklistCriteria);
    compositeCriteria.addCriteria(statusCriteria);

    return compositeCriteria.meetCriteria(state.parentSuperorderActivities);
  },

  parentSuperorderGreenAdditionalActivities: (state) => {
    const compositeCriteria = new CompositeCriteria();
    const checklistCriteria = new ChecklistCriteria(false);
    const statusCriteria = new StatusCriteria(GREEN_ACTIVITY_STATUS_ID);

    compositeCriteria.addCriteria(checklistCriteria);
    compositeCriteria.addCriteria(statusCriteria);

    return compositeCriteria.meetCriteria(state.parentSuperorderActivities);
  },

  parentSuperorderYellowActivities: (state) => {
    const compositeCriteria = new CompositeCriteria();
    const statusCriteria = new StatusCriteria(YELLOW_ACTIVITY_STATUS_ID);

    compositeCriteria.addCriteria(statusCriteria);

    return compositeCriteria.meetCriteria(state.parentSuperorderActivities);
  },

  parentSuperorderRedActivities: (state) => {
    const compositeCriteria = new CompositeCriteria();
    const statusCriteria = new StatusCriteria(RED_ACTIVITY_STATUS_ID);

    compositeCriteria.addCriteria(statusCriteria);

    return compositeCriteria.meetCriteria(state.parentSuperorderActivities);
  },
};
